// Tiny class-name join: keep the truthy parts and space-separate them. Lets components pass
// `false`/`null`/`undefined` for conditional classes and an optional caller `className` without
// the repeated `${x ? ` ${x}` : ""}` template idiom. Output matches that idiom byte-for-byte.
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
